import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import { Box, Button, Chip, Paper, Stack, Typography } from "@mui/material";
import { GridToolbar } from "@mui/x-data-grid";
import { useEffect, useState, useContext, useCallback } from "react";
import { ThemeContext } from '../../context/ThemeContext';
import { HiTemplate } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import NodataImg from "../../assets/images/noData.png";
import Appbar from "../../components/Appbar";
import Body from "../../components/Body";
import Drawer from "../../components/Drawer";
import DataGridComponent from "../../components/DataGridComponent";
import DeleteBanner from './DeleteBanner';
import { managechannelBannerApi, resetChannelBanner } from '../../store/channel-banner/ManageChannelBanner';
import CustomGridToolbar from "../../components/CustomGridToolbarWithoutDownload";
import apiRoutes from "../../store/apiConfigs";
import PermissionGate from "../../components/PermissionGate";

export default function ManageBanner() {
  const manageSplashScreen = useSelector((state) => state?.managechannelBanner);
  const { result, order_category, loading, total } = manageSplashScreen;
  const { paginationModel, setPaginationModel } = useContext(ThemeContext)

  const [queryOptions, setQueryOptions] = useState({});

  const onFilterChange = useCallback((filterModel) => {
    setQueryOptions({ filterModel: { ...filterModel } });
  }, []);
  const order_deatils = JSON.parse(localStorage.getItem("order_deatils"));
  const [isDownload, setIsDownload] = useState(false)

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [deleteId, setDeleteId] = useState(null);
  const [queryValue, setqueryValue] = useState(null);
  const [datashow, setDataShow] = useState([]);
  const [notSelectedProductModel, setNotSelectedProductModel] = useState(false);
  useEffect(() => {
    return () => {
      dispatch(resetChannelBanner());
    }
  }, [])
  const columns = [
    {
      field: "id",
      headerName: "Banner Id",
      width: 150,
      filterable: false,
      sortable: false,
    },
    {
      field: "order",
      headerName: "Order",
      width: 200,
      filterable: false,
      sortable: false,
    },
    {
      field: "channel",
      headerName: "Channel Name",
      width: 200,
      filterable: true,
      sortable: false,
      renderCell: (data) => (
        <>
          {data.row.channel_details.channel_name}
        </>
      )
    },
    {
      field: "page_key",
      headerName: "Page Type",
      width: 250,
      filterable: false,
      sortable: false,
      renderCell: (rowData) => (<Typography>
        {String(rowData?.row?.page_key).includes("Web") ? "WEB" : "APP"}
      </Typography>)
    },
    {
      field: "image",
      headerName: "Banner Image",
      width: 250,
      filterable: false,
      sortable: false,
      renderCell: (params) => (<img width={200} height={100} src={params.row.banner} alt='banner image' />)
    },
    {
      field: "is_active",
      headerName: "Status",
      width: 150,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <>
          {params?.row?.published ? (
            <Chip color="success" label="Active" variant="outlined" />
          ) : (
            <Chip color="error" label="InActive" variant="outlined" />
          )}
        </>
      ),
    },
    {
      field: "update_banner",
      headerName: "Update banner",
      width: 150,
      filterable: false,
      sortable: false,
      disableExport: true,
      renderCell: (row) => (
        <>
          <PermissionGate module="channel" action="update">
            <Button
              color="info"
              endIcon={<EditIcon />}
              label="Available" variant="outlined"
              onClick={() => handleNavigation(row.id)}
            >
              Edit
            </Button>
          </PermissionGate>
        </>
      ),
    },
    {
      field: "delete_banner",
      headerName: "Delete banner",
      width: 150,
      filterable: false,
      sortable: false,
      disableExport: true,
      renderCell: (row) => (
        <>
          <PermissionGate module="channel" action="delete">
            <Button
              endIcon={<DeleteOutlineIcon />}
              color="error"
              variant="outlined"
              style={{ marginLeft: "5px" }}
              onClick={() => {
                setNotSelectedProductModel(true)
                setDeleteId(row.id)
              }}
            >
              Delete
            </Button>
          </PermissionGate>
        </>
      ),
    },
  ];


  const handleNavigation = async (id) => {

    navigate(`/edit-channel-banner/${id}`)
  };
  const addToCartHandler = async () => {
    navigate("/add-channel-banner");
  };

  const backToCatHandler = () => {
    navigate("/category");
  };

  useEffect(() => {
    const filterModel = queryOptions?.filterModel;
    const items = filterModel?.items;
    const firstItem = items && items.length > 0 ? items[0] : {};
    const quickFilterValues = filterModel?.quickFilterValues;

    const query = {
      page: paginationModel?.page + 1,
      page_size: paginationModel?.pageSize,
      field: firstItem.field || '',
      operator: firstItem.operator || (quickFilterValues && "contains") || '',
      value: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || '',
      search: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || '',
    };
    setqueryValue(query)
    dispatch(managechannelBannerApi(query));
  }, [dispatch, queryOptions, paginationModel]);
  useEffect(() => {
    setDataShow(result?.result)
  }, [result]);

  const getRowSpacing = useCallback((params) => {
    return {
      top: params.isFirstVisible ? 0 : 5,
      bottom: params.isLastVisible ? 0 : 5,
    };
  }, []);
  return (
    <>
      <Appbar />
      <Drawer />
      <Body>


        <Stack direction="row" spacing={1} sx={{ my: 2 }} alignItems="center">
          <HiTemplate size={30} />
          <Typography>Manage Channel Banner</Typography>
        </Stack>

        <Stack sx={{ my: 2 }} justifyContent="space-between" direction="row">
          <Stack direction="row" spacing={1}>
            <PermissionGate module="channel" action="create">
              <Button
                onClick={addToCartHandler}
                variant="contained"
              >
                Add New Channel Banner
              </Button>
            </PermissionGate>
          </Stack>
        </Stack>

        <Paper elevation={0}>
          <DataGridComponent
            loading={loading}
            rowCount={total}
            pageSize={paginationModel?.pageSize}
            onPageSizeChange={(newPageSize) => {
              setPaginationModel({
                ...paginationModel,
                pageSize: newPageSize,
              })
            }}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            sx={{
              height: 500
            }}
            getRowId={(row) => row.id}
            getRowSpacing={getRowSpacing}
            rows={datashow || []}
            columns={columns}
            onFilterModelChange={onFilterChange}
            slots={{
              noRowsOverlay: () => (
                <Box className="noData">
                  <img src={NodataImg} alt="no data found" />
                </Box>
              ),
              toolbar: (props) =>
                (CustomGridToolbar({ ...props, moduleType: "channelBannerManagement", queryOptions: queryOptions, paginationModel: paginationModel, isDownload: isDownload, setIsDownload: setIsDownload, apiUrl: apiRoutes.channelBannerAction("add") })),
            }}
            slotProps={{
              loadingOverlay: {
                variant: 'linear-progress',
                noRowsVariant: 'linear-progress',
              },
              toolbar: {
                showQuickFilter: true,
              },
            }}
          />
        </Paper>

      </Body>

      <DeleteBanner
        open={notSelectedProductModel}
        setOpen={setNotSelectedProductModel}
        id={deleteId}
        query={queryValue}
      />
    </>
  );
}
